import dateformat from 'dateformat'
import { translateManager as t } from '../services/TranslateManager'
import dates from '../locale/custom/dates.json'
import { isClient } from './runtimeUtils'
import { getRootLoaderData } from './remixClientUtils'
import { LANGUAGES } from 'locale/Translation.consts'

if (isClient()) {
  const language = getRootLoaderData()?.language || 'en'
  dateformat.i18n.dayNames = dates[language].dayNames.concat(
    dates[language].dayNames
  )
  dateformat.i18n.monthNames = dates[language].monthNames.concat(
    dates[language].monthNames
  )
}

// In Japanese date formatting:
// 4月 (四月) = month 4 (April)
// 27日 = day 27
function formatJapaneseMonthDay(date) {
  return `${date.getMonth() + 1}月${date.getDate()}日`
}

function shouldUseJapaneseMonthDayFormat(format) {
  return (
    t.getLanguage() === LANGUAGES.JAPANESE &&
    (!format || format === 'mmm d' || format === 'mmmm d')
  )
}

export function isoToDeliveryDate(isoString, format = t.getDateFormat()) {
  const date = new Date(isoString)

  if (shouldUseJapaneseMonthDayFormat(format)) {
    return formatJapaneseMonthDay(date)
  }

  return dateformat(date, format)
}

// Output format: "May 25 - May 29"
export function formatIsoDateRange(startDateISO, endDateISO) {
  if (t.getLanguage() === LANGUAGES.JAPANESE) {
    return `${formatJapaneseMonthDay(
      new Date(startDateISO)
    )}～${formatJapaneseMonthDay(new Date(endDateISO))}`
  }

  const rangeDateFormat = 'mmm d'
  return `${isoToDeliveryDate(
    startDateISO,
    rangeDateFormat
  )} - ${isoToDeliveryDate(endDateISO, rangeDateFormat)}`
}

export function isoToOrderManagementDate(isoString) {
  return isoString
    ? dateformat(new Date(isoString), 'mmmm dd, yyyy, hh:mm:ss TT')
    : null
}

export function addDaysToIsoDate(isoString, days) {
  const newDate = new Date(isoString)
  newDate.setDate(newDate.getDate() + days)
  return newDate.toISOString()
}

export const utcTimestampToLocalTime = (timestamp) => {
  return new Date(timestamp + new Date().getTimezoneOffset() * 60000)
}

// Calculate the number of days between two iso dates
export function daysBetween(startDateISO, endDateISO) {
  const start = new Date(startDateISO)
  const end = new Date(endDateISO)
  return Math.floor((end - start) / 86400000)
}
